import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {useWhatsappParams} from './hooks/useSubscribeToWhatsappNewsletter';

const SubscribeToWhatsappNewsletterLazy = lazy(() =>
  import('./SubscribeToWhatsappNewsletter.eager').then(mod => ({
    default: mod.SubscribeToWhatsappNewsletter,
  })),
);

export const SubscribeToWhatsappNewsletter = () => {
  const {whatsappUUIDToken, countryCode} = useWhatsappParams();
  const {isAuthenticated, isUserDataLoading} = useIsAuthenticated();

  if (!whatsappUUIDToken || (!isAuthenticated && isUserDataLoading)) {
    return null;
  }

  return (
    <SubscribeToWhatsappNewsletterLazy
      whatsappUUIDToken={whatsappUUIDToken}
      countryCode={countryCode || ''}
    />
  );
};
